<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- Loader -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <!-- Amount To Be Settled Header Row -->
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-sm-2"></div>
      <div class="col-sm-4"></div>
      <div class="col-sm-2" style="text-align: right">
        <label><b>Amount To Be Settled:</b></label>
      </div>
      <div class="col-sm-2">
        <input type="text" 
               class="form-control" 
               [ngModel]="amountToSettle" 
               readonly
               style="cursor: text;">
      </div>
    </div>
    <hr>

    <!-- Settlement Forms -->
    <form name="settlementForm" novalidate>
      @for (settlement of settlements; track trackByIndex(i, settlement); let i = $index) {
<div>
        
        <!-- ROW 1: Settlement Type + BUC/ADN (if IBS) -->
        <div class="row">
          <!-- Remove button column (first item = empty, others = minus icon) -->
          @if (i === 0) {
<div class="col-md-1 gt-edit-col"></div>
}
          @if (i !== 0) {
<div class="col-md-1 gt-edit-col">
            <i (click)="removeSettlement(i)" 
               class="fa fa-minus-circle color-red" 
               style="cursor: pointer;"
               title="Remove This Settlement"></i>
          </div>
}

          <!-- Settlement Type -->
          <div class="col-sm-2">
            <label><b>Settlement Type:</b></label>
            <select class="form-control" 
                    [(ngModel)]="settlement.type" 
                    [name]="'settlement_type_' + i"
                    required>
              <option [ngValue]="null">Select</option>
              @for (s of types; track $index) {
<option [ngValue]="s">{{ s.label }}</option>
}
            </select>
          </div>

          <!-- BUC Code (IBS only) -->
          @if (settlement.type?.value === 'IBS') {
<div class="col-sm-3">
            <label><b>BUC Code:</b></label>
            <input type="text" 
                   class="form-control" 
                   [(ngModel)]="settlement.buc" 
                   [name]="'buc_' + i"
                   (blur)="validateBucAdn(i)"
                   placeholder="Enter"
                   required>
          </div>
}

          <!-- ADN Code (IBS only) -->
          @if (settlement.type?.value === 'IBS') {
<div class="col-sm-5">
            <label><b>ADN Code:</b></label>
            <div class="input-group">
              <span class="input-group-addon" 
                    [ngClass]="{'btn-success': settlement.valid === true, 'btn-danger': settlement.valid === false}">
                <i class="fa" 
                   [ngClass]="{'fa-check': settlement.valid === true, 'fa-times': settlement.valid === false, 'fa-spinner fa-spin': settlement.valid === 'loading'}"></i>
              </span>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="settlement.adn" 
                     [name]="'adn_' + i"
                     (blur)="validateBucAdn(i)"
                     placeholder="Enter"
                     required>
            </div>
          </div>
}

          <!-- Empty space column -->
          <div class="col-sm-2"></div>
        </div>

        <!-- ROW 2: ERP (non-IBS) + dependent fields + Amount -->
        <div class="row" style="margin-top: 5px">
          <!-- Empty first column -->
          <div class="col-md-1 gt-edit-col"></div>

          <!-- ERP (non-IBS only - shows when type is not IBS, including when nothing selected) -->
          @if (settlement.type?.value !== 'IBS') {
<div class="col-sm-2">
            <label><b>ERP:</b></label>
            <select class="form-control" 
                    [(ngModel)]="settlement.erp" 
                    [name]="'erp_' + i"
                    required>
              <option [ngValue]="null">Select</option>
              @for (e of erp; track $index) {
<option [ngValue]="e">{{ e.label }}</option>
}
            </select>
          </div>
}

          <!-- ME Code (NAV/ORA only) -->
          @if (settlement.type?.value !== 'IBS' && settlement.erp?.value !== 'CCL' && (settlement.erp?.value === 'NAV' || settlement.erp?.value === 'ORA')) {
<div class="col-sm-3">
            <label><b>ME Code:</b></label>
            <input type="text" 
                   class="form-control" 
                   [(ngModel)]="settlement.me" 
                   [name]="'me_code_' + i"
                   placeholder="Enter"
                   required>
          </div>
}

          <!-- LEID (NAV/ORA only) -->
          @if (settlement.type?.value !== 'IBS' && settlement.erp?.value !== 'CCL' && (settlement.erp?.value === 'NAV' || settlement.erp?.value === 'ORA')) {
<div class="col-sm-3">
            <label><b>LEID:</b></label>
            <input type="text" 
                   class="form-control" 
                   [(ngModel)]="settlement.leid" 
                   [name]="'leid_' + i"
                   placeholder="Enter LEID"
                   required>
          </div>
}

          <!-- System Description (Other only) -->
          @if (settlement.type?.value !== 'IBS' && settlement.erp?.value !== 'CCL' && settlement.erp?.value === 'Other') {
<div class="col-sm-6">
            <label><b>System Description:</b></label>
            <input type="text" 
                   class="form-control" 
                   [(ngModel)]="settlement.sys_desc" 
                   [name]="'sys_desc_' + i"
                   placeholder="Enter System Description"
                   required>
          </div>
}

          <!-- Empty space when ERP not selected yet (non-IBS mode) -->
          @if (settlement.type?.value !== 'IBS' && !settlement.erp) {
<div class="col-sm-6"></div>
}

          <!-- Company Code (CCL only) -->
          @if (settlement.type?.value !== 'IBS' && settlement.erp?.value === 'CCL') {
<div class="col-sm-3">
            <label><b>Company Code:</b></label>
            <div class="input-group">
              <input type="text" 
                     class="form-control input-sm" 
                     [ngModel]="settlement.cCodeSet ? settlement.company_code?.NAME : ''"
                     (ngModelChange)="searchCompanyCodes($event)"
                     [name]="'company_code_' + i"
                     [disabled]="settlement.cCodeSet"
                     placeholder="begin typing to select company code"
                     required>
              <span class="input-group-addon">
                @if (loadingCompanyCodes) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
                @if (!loadingCompanyCodes && !settlement.cCodeSet) {
<span><i class="fa fa-search"></i></span>
}
                @if (settlement.cCodeSet) {
<span style="cursor: pointer;" (click)="clearSelection(settlement)">
                  <i class="fa fa-times"></i>
                </span>
}
              </span>
            </div>
            <!-- Typeahead dropdown -->
            @if (companyCodes.length > 0 && !settlement.cCodeSet) {
<div class="typeahead-dropdown">
              @for (ccode of companyCodes; track $index) {
<div 
                   class="typeahead-item"
                   (click)="onCompanyCodeSelect(settlement, ccode)">
                {{ ccode.NAME }}
              </div>
}
            </div>
}
            @if (noResults) {
<div class="btn btn-sm btn-danger" style="margin-top: 5px">
              <i class="fa fa-times"></i> No Results Found
            </div>
}
          </div>
}

          <!-- Currency (CCL only) -->
          @if (settlement.type?.value !== 'IBS' && settlement.erp?.value === 'CCL' && settlement.foreign_curr) {
<div class="col-sm-3">
            <label><b>Currency:</b></label>
            <input type="text" 
                   class="form-control" 
                   [ngModel]="settlement.foreign_curr" 
                   [name]="'currency_' + i"
                   disabled>
          </div>
}

          <!-- Spacer for IBS type -->
          @if (settlement.type?.value === 'IBS') {
<div class="col-sm-8"></div>
}

          <!-- Amount - ALWAYS visible on the right -->
          <div class="col-sm-2">
            <label><b>Amount:</b> <b class="pull-right">{{ settlement.amount | number }}</b></label>
            <input type="number" 
                   class="form-control" 
                   [(ngModel)]="settlement.amount" 
                   [name]="'amount_' + i"
                   placeholder="Enter Amount"
                   (ngModelChange)="onChange()"
                   required>
          </div>
        </div>

        <hr>
      </div>
}

      <!-- Add Settlement Row + Remaining Amount -->
      <hr>
      <div class="row">
        <div class="col-md-1 gt-edit-col">
          <i (click)="addSettlement()" 
             class="fa fa-plus-circle color-green" 
             style="cursor: pointer;"
             title="Add Settlement Method"></i>
        </div>
        <div class="col-sm-2"></div>
        <div class="col-sm-2"></div>
        <div class="col-sm-4" style="text-align: right">
          <label><b>Remaining Amount:</b></label>
        </div>
        <div class="col-sm-2">
          <div class="input-group">
            <span class="input-group-addon">{{ rowData.FC }}</span>
            <input type="text" 
                   class="form-control" 
                   [ngModel]="settleAmount" 
                   disabled>
          </div>
        </div>
      </div>
    </form>
  </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save Settlement
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
  <button class="delete-button" 
          type="button" 
          (click)="deleteSettlement()">Delete</button>
</div>
